import { LinkProps, Link } from 'react-router-dom'
import classNames from 'classnames'

import styles from './CustomLink.module.scss'

export interface CustomLinkProps extends LinkProps {
  disabled?: boolean
}

export const CustomLink = ({ disabled, ...props }: CustomLinkProps) => {
  if (disabled)
    return (
      <div className={classNames(disabled && styles.disabled, props.className)}>
        {props.children}
      </div>
    )
  return <Link {...props} to={disabled ? '#' : props.to} />
}

export default CustomLink
